export default __webpack_public_path__ + "static/media/George_Street_Shuffle.c0459c27.mp3";